import Cookies from 'js-cookie'

const COOKIE_NAME = 'MessageClosed'
const EL_SELECTOR = '.js-Message'
const EL = document.querySelector(EL_SELECTOR)
const COOKIE_EXPIRES_DAYS = 1

class Message {
  constructor() {
    if(!Cookies.get(COOKIE_NAME) && EL){
      this.init()
      this.show()
    }
  }

  show = () => {
    EL.classList.remove('not-loaded')
  }

  setCloseCookie = () => {
    Cookies.set(COOKIE_NAME, 'true', { expires: COOKIE_EXPIRES_DAYS })
  }

  init = () => {
    const close = EL.querySelector('.message__close')

    close.addEventListener('click', (e) => {
      this.setCloseCookie()

      document.body.classList.add('message-is-closed')
    })
  }
}

new Message();
